import React, { useState } from 'react';
import { MuiBox } from 'theme/material-ui';
import { DisplayAddress, MuiRow, PersonalInfoInputLabel, PersonalInfoSection } from './styled';
import Config from 'react-native-config';
import { EditAddressScreen } from './EditAddress';
import { Address } from 'store/preRegistration/types';
import { FontSize } from 'modules/styles/variables';
import Typography from 'components/UI/Typography';
import Button from '@material-ui/core/Button';

const ALLOW_UPDATE = Config.PRE_REG_ALLOW_SAVE_PATIENT_DATA === 'enabled';

export function HomeAddress({
  homeAddress,
  handleSubmit
}: {
  homeAddress: Address;
  handleSubmit: (address: Address) => void;
}) {
  const [open, setOpen] = useState(false);

  return (
    <MuiRow>
      <MuiBox>
        <PersonalInfoInputLabel required={!!ALLOW_UPDATE}>Home Address</PersonalInfoInputLabel>
        <PersonalInfoSection>
          <EditAddressScreen
            homeAddress={homeAddress}
            handleSubmit={(address: Address) => {
              setOpen(false);
              handleSubmit(address);
            }}
            open={open}
            onClose={() => setOpen(false)}
          />
          {homeAddress ? (
            <DisplayAddress>
              <Typography fontSize={FontSize.base}>
                {homeAddress.address2
                  ? `${homeAddress.address1} ${homeAddress.address2}`
                  : homeAddress.address1}
              </Typography>
              <Typography fontSize={FontSize.base}>{`
                  ${homeAddress.city}, ${homeAddress.state} ${homeAddress.zip}
                `}</Typography>
            </DisplayAddress>
          ) : (
            <DisplayAddress></DisplayAddress>
          )}
          {ALLOW_UPDATE ? (
            <Button color="primary" onClick={() => setOpen(true)}>
              Edit
            </Button>
          ) : null}
        </PersonalInfoSection>
      </MuiBox>
    </MuiRow>
  );
}
